module.exports = __webpack_public_path__ + "static/img/qbz03.ea0f0b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/qbz03.png
// module id = KEsz
// module chunks = 0